import type { FC, ReactNode } from 'react'
import { createContext, useState, useMemo, useContext } from 'react'

import type { Locale } from '@skytech/types'
import { DEFAULT_LOCALE } from '@skytech/utils'

type AppContext = {
  locale: Locale
  setLocale: (v: Locale) => void
}

const Context = createContext<AppContext>({
  locale: DEFAULT_LOCALE,
  setLocale: () => {},
})

export const AppContextProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [locale, setLocale] = useState<Locale>(DEFAULT_LOCALE)

  const value: AppContext = useMemo(
    () => ({
      locale,
      setLocale,
    }),
    [locale]
  )

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export const useAppContext = () => useContext(Context)
